<template>
    <div class="onboarding">
        <router-view
            :token="token"
            @step="setStep"
            @proceed="proceed"
        ></router-view>

        <div
            v-if="step !== 0"
            class="onboarding__progress"
        >
            <button :class="{ active: step === 1 }"></button>
            <button :class="{ active: step === 2 }"></button>
            <button :class="{ active: step === 3 }"></button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['admin'],

    data() {
        return {
            token: this.$route.params.token,
            step: 0,
        }
    },

    methods: {
        setStep(stepNumber) {
            this.step = stepNumber
        },

        proceed(routeName) {
            this.$router.push({ name: routeName })
        },
    },
}
</script>
